import { queryOptions, useQuery } from '@tanstack/react-query'
import { useAuthTokensRevision } from '@/features/auth/hooks/useAuthTokensRevision'
import type { BootstrapData } from '@/features/bootstrap/types/bootstrap'
import { apiClient } from '@/shared/api/client'
import { getAccessToken } from '@/shared/lib/auth-tokens'

export const bootstrapQueryKey = ['bootstrap'] as const

export function bootstrapQueryOptions() {
  return queryOptions({
    queryKey: bootstrapQueryKey,
    queryFn: (): Promise<BootstrapData> => apiClient.bootstrap.get(),
  })
}

export function isBootstrapQueryEnabled(): boolean {
  return Boolean(getAccessToken())
}

export function useBootstrapQuery() {
  const tokensRevision = useAuthTokensRevision()
  void tokensRevision

  return useQuery({
    ...bootstrapQueryOptions(),
    enabled: isBootstrapQueryEnabled(),
  })
}
